module.exports = __webpack_public_path__ + "static/media/admin_bg.fe5a292c.jpg";